import { SelfServiceAPI } from 'types';
import { toDisplayDateFormat } from 'lib/utils/date';
import LineItem from 'components/LineItem';

export interface QantasTravelPassLineItemProps {
  type: SelfServiceAPI.TransactionType;
  createdAt: string | Date;
  cardNumber?: string | null;
  total: SelfServiceAPI.Total;
}

const QantasTravelPassLineItem = ({ type, createdAt, cardNumber = '', total }: QantasTravelPassLineItemProps) => (
  <LineItem title="Qantas TravelPass" totals={[total]}>
    {type === 'REFUND'
      ? `Refunded on ${toDisplayDateFormat(createdAt)} to Qantas TravelPass ${cardNumber || ''}`
      : `Redeemed on ${toDisplayDateFormat(createdAt)} using Qantas TravelPass ${cardNumber || ''}`}
  </LineItem>
);

export default QantasTravelPassLineItem;
